import React, {useState, useContext} from 'react';
import { AlertCircle , Edit2, X, Save } from "lucide-react";
import { API_URL, doApiMethod} from "../services/apiService";
import {FamilyContext} from "../Context/FamilyHeadContext";

const Announcements = ({ setSubmitStatus }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [editedAnnouncement, setEditedAnnouncement] = useState('');
    const { currentAnnouncement, setCurrentAnnouncement } = useContext(FamilyContext);

    const handleEditSubmit = async () => {
        try {
            await doApiMethod(`${API_URL}/user-count/content`, "PATCH", {
                content: editedAnnouncement
            });

            setCurrentAnnouncement(editedAnnouncement);
            setIsEditing(false);
            setSubmitStatus({ type: 'success', message: 'ההודעה עודכנה בהצלחה' });
        } catch (err) {
            setSubmitStatus({ type: 'error', message: 'שגיאה בעדכון ההודעה' });
        }
    };
    const convertLinksInText = (text) => {
        // תומך בפורמט: [[url|text]]
        return text.replace(/\[\[(.*?)\|(.*?)\]\]/g, (match, url, text) => (
            `<Lint to="${url}" class="text-[#937c5d] hover:text-[#c9a66c] underline">${text}</Lint>`
        ));
    };

    return (
        <div className="bg-white rounded-xl p-6 shadow-[0_4px_20px_rgba(201,166,108,0.08)]">
            {/* כותרת */}
            <h2 className="text-xl font-heebo font-bold text-[#937c5d] mb-6 flex items-center gap-2
                border-b border-[#e6dfd4] pb-4">
                <AlertCircle className="w-6 h-6" />
                ניהול הודעות מנהל
            </h2>

            {/* הצגת ההודעה הנוכחית */}
            { !isEditing && (
                <div className="mb-8 p-4 bg-[#937c5d]/10 rounded-xl">
                    <div className="flex justify-between items-start mb-2">
                        <h3 className="font-heebo font-bold text-[#937c5d]">הודעה נוכחית:</h3>
                        <button
                            onClick={() => {
                                setIsEditing(true);
                                setEditedAnnouncement(currentAnnouncement);
                            }}
                            className="text-[#937c5d] hover:text-[#c9a66c] transition-colors"
                        >
                            <Edit2 size={18}/>
                        </button>
                    </div>
                    <div
                        className="text-[#4a3f30] font-heebo"
                        dangerouslySetInnerHTML={{__html: convertLinksInText(currentAnnouncement)}}
                    />
                </div>
            )}

            {/* עריכת הודעה קיימת */}
            {isEditing && (
                <div className="mb-8 space-y-4">
                    <h3 className="font-heebo font-bold text-[#937c5d]">עריכת הודעה:</h3>
                    <textarea
                        value={editedAnnouncement}
                        onChange={(e) => setEditedAnnouncement(e.target.value)}
                        className="w-full p-4 rounded-xl border-2 border-[#e1ddd7] bg-white/90
                            text-[#4a3f30] placeholder-[#937c5d]/60 text-lg font-heebo
                            focus:outline-none focus:border-[#c9a66c] focus:ring-2 focus:ring-[#c9a66c]/20
                            transition-all duration-300 resize-none min-h-[100px]"
                    />
                    <div className="flex gap-2 justify-end">
                        <button
                            onClick={() => setIsEditing(false)}
                            className="px-4 py-2 text-[#937c5d] rounded-xl flex items-center gap-2
                                hover:bg-[#937c5d]/10 font-heebo transition-all duration-300"
                        >
                            <X size={18} />
                            ביטול
                        </button>
                        <button
                            onClick={handleEditSubmit}
                            className="px-4 py-2 bg-gradient-to-r from-[#937c5d] to-[#c9a66c]
                                text-white rounded-xl flex items-center gap-2
                                hover:from-[#826e52] hover:to-[#b89660] font-heebo
                                transition-all duration-300"
                        >
                            <Save size={18} />
                            שמור שינויים
                        </button>
                    </div>
                </div>
            )}

            {/* יצירת הודעה חדשה */}
            {/*<div className="space-y-4">*/}
            {/*    <h3 className="font-heebo font-bold text-[#937c5d]">פרסום הודעה:</h3>*/}
            {/*    <textarea*/}
            {/*        placeholder="תוכן ההודעה..."*/}
            {/*        value={importantMessage}*/}
            {/*        onChange={(e) => setImportantMessage(e.target.value)}*/}
            {/*        className="w-full p-4 rounded-xl border-2 border-[#e1ddd7] bg-white/90*/}
            {/*            text-[#4a3f30] placeholder-[#937c5d]/60 text-lg font-heebo*/}
            {/*            focus:outline-none focus:border-[#c9a66c] focus:ring-2 focus:ring-[#c9a66c]/20*/}
            {/*            transition-all duration-300 resize-none min-h-[150px]"*/}
            {/*    />*/}
            {/*    <button*/}
            {/*        onClick={handleImportantMessageSubmit}*/}
            {/*        className="px-6 py-3 bg-gradient-to-r from-[#937c5d] to-[#c9a66c]*/}
            {/*            text-white rounded-xl flex items-center gap-2*/}
            {/*            hover:from-[#826e52] hover:to-[#b89660] font-heebo*/}
            {/*            focus:outline-none focus:ring-2 focus:ring-[#c9a66c]/50*/}
            {/*            transition-all duration-300"*/}
            {/*    >*/}
            {/*        <Send size={18} />*/}
            {/*        פרסם הודעת מנהל*/}
            {/*    </button>*/}
            {/*</div>*/}
        </div>
    );
};

export default Announcements;